export default function ErrorPage() {
    return (
        <div className="ErrorPage">
            ErrorPage
        </div>
    )
}